module.exports = __webpack_public_path__ + "img/169.17c2010a.jpg";